import uniq from 'lodash/uniq';
import merge from 'lodash/merge';
import { createContext, useContext } from 'react';
import { ThemeId } from '@/interfaces/theme';
import { defaultTheme, themes } from '@/config/theme';
import universalDesignSystem, { grayColorPallet } from '@/config/colorPallets/universalDesignSystem';
import { toRGB } from '@/utils/colors';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ThemeContext = /*#__PURE__*/createContext({
  theme: defaultTheme,
  styles: {}
});

const ThemeProvider = _ref => {
  let {
    children,
    config
  } = _ref;
  const activeTheme = useMemo(() => {
    const activeThemeId = config.theme ?? ThemeId.UniversalDesignLight;
    return themes.find(theme => theme.id === activeThemeId) || defaultTheme;
  }, [config.theme]);
  return /*#__PURE__*/_jsx(ThemeContext.Provider, {
    value: {
      theme: activeTheme,
      colorPallet: config.colorPallet || defaultTheme.colorPallets[0].colors,
      colorPresets: getDefaultColorPresets(config),
      baseColorPresets: getBaseColorPresets(config),
      styles: getThemeStyles(config)
    },
    children: children
  });
};

export const useTheme = () => useContext(ThemeContext); // Create a theme styles object by merging the default theme styles
// with the selected theme's styles.

const getThemeStyles = config => {
  return merge({}, defaultTheme.styles, config.stylesTheme);
}; // Create a list of theme swatches based on the current theme
// and active color palette, including (in order):
// palette colors, any black, any white, body font color, header font color,
// and all the theme's gray colors.


const getDefaultColorPresets = config => {
  const themeColorPallet = config.colorPallet || defaultTheme.colorPallets[0].colors;
  return uniq([...themeColorPallet, ...getBaseColorPresets(config)].filter(Boolean) // Remove any null values
  .map(toRGB) // Convert to RGB for consistency and to remove duplicates
  );
};

export const getBaseColorPresets = config => {
  const stylesTheme = config.stylesTheme || defaultTheme.styles;
  return uniq([universalDesignSystem.gray100, universalDesignSystem.white, stylesTheme['body-font-color'], stylesTheme['heading-font-color'], ...grayColorPallet].filter(Boolean) // Remove any null values
  );
};
export default ThemeProvider;